import { render, staticRenderFns } from "./America.vue?vue&type=template&id=00f1ca62&scoped=true&"
import script from "./America.vue?vue&type=script&lang=js&"
export * from "./America.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f1ca62",
  null
  
)

export default component.exports